/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Metrics_Filename_TitleInputs */



/**
* | output |
* | --- |
* | "Export Speaker Metrics" |
*
* @param {Speakers_Metrics_Filename_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_filename_title = /** @type {((inputs?: Speakers_Metrics_Filename_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Filename_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Export Speaker Metrics")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export Speaker Metrics")
	if (locale === "it") return /** @type {LocalizedString} */ ("Export Speaker Metrics")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Export Speaker Metrics")
	if (locale === "es") return /** @type {LocalizedString} */ ("Export Speaker Metrics")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Export Speaker Metrics")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Export Speaker Metrics")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Export Speaker Metrics")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Export Speaker Metrics")
	return /** @type {LocalizedString} */ ("Export Speaker Metrics")
});